import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { HarmonicsTable } from 'sharedComponents';
import { bearingFrequencyTypes } from './constants';

function BearingFaultHarmonicsTable(props) {
    const {
        bearingFaultFrequencies,
        frequencyUnitSymbol,
        bearingFaultType
    } = props;


    const getDashStyle = (frequencyName) => {
        if (frequencyName?.includes(bearingFrequencyTypes.BSF.name)) {
            return bearingFrequencyTypes.BSF;
        } else if (frequencyName?.includes(bearingFrequencyTypes.BPFI.name)) {
            return bearingFrequencyTypes.BPFI;
        } else if (frequencyName?.includes(bearingFrequencyTypes.BPFO.name)) {
            return bearingFrequencyTypes.BPFO;
        }
        return null;
    };

    const getBearingFaultFrequencies = () => {
        const filtered = bearingFaultFrequencies?.filter(frequency => frequency?.bearingType?.includes(bearingFaultType)) ?? [];

        return filtered.map(item => {
            const bearingType = getDashStyle(item?.name);
            const style = bearingType?.style;
            return { ...item, lineStyle: style };
        });
    };

    return (
        <div className='bearing-fault-harmonics-table-container'>
            <HarmonicsTable
                title={translate('ABB.Powertrain.Frontend.bearingFaultHarmonicsLabel')}
                data={getBearingFaultFrequencies()}
                frequencyUnitSymbol={frequencyUnitSymbol}
                dividerEvery={3}
            />
        </div>
    );
}

BearingFaultHarmonicsTable.propTypes = {
    bearingFaultFrequencies: PropTypes.array,
    frequencyUnitSymbol: PropTypes.string,
    bearingFaultType: PropTypes.string,
};

export default BearingFaultHarmonicsTable;
